import React, { createContext, useContext } from "react";
import { Toaster } from 'react-hot-toast';
import { v4 as uuid } from 'uuid';

type CommonContextType = {
    children: React.ReactNode
}

type CommonStoreType = {
    createUUID: () => string,
}

const CommonContext = createContext({} as CommonStoreType);
const useCommonContext = () => useContext(CommonContext)
const CommonProvider = ({ children }: CommonContextType) => {
    const store: CommonStoreType = {
        createUUID: () => {
            return uuid();
        },
    }
    return (
        <CommonContext.Provider value={store}>
            {children}

            <Toaster
                toastOptions={{
                    success: {
                        style: {
                            background: '#1B7F36',
                            color: "#fff"
                        },
                    },
                    error: {
                        style: {
                            background: '#A30F26',
                            color: "#fff"

                        },
                    },
                    position: "bottom-right"
                }}
            />
        </CommonContext.Provider>
    );
}
export {
    CommonProvider,
    useCommonContext
};

